var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustProviderMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 653.905,
    height: 278.169,
    viewBox: "0 0 653.905 278.169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2755.347 -4814.277)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 69.607,
    height: 69.607,
    rx: 3,
    transform: "translate(2755.847 4814.777)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2798.364 4862.432a1.1 1.1 0 011.2.239l2.034 2.043a.739.739 0 001.044 0h0l3.137-3.137a.738.738 0 000-1.044l-2.044-2.035a1.1 1.1 0 01-.239-1.2l1.7-4.086a1.1 1.1 0 011.021-.678h2.882a.738.738 0 00.739-.736h0v-4.436a.739.739 0 00-.739-.737h-2.882a1.1 1.1 0 01-1.021-.679l-1.7-4.085a1.1 1.1 0 01.239-1.2l2.044-2.035a.737.737 0 000-1.043l-3.137-3.137a.737.737 0 00-1.044 0h0l-2.032 2.043a1.1 1.1 0 01-1.2.238l-4.085-1.7a1.1 1.1 0 01-.679-1.019v-2.884a.738.738 0 00-.739-.74h-4.435a.741.741 0 00-.739.74v2.884a1.1 1.1 0 01-.68 1.019l-4.085 1.7a1.105 1.105 0 01-1.2-.238l-2.033-2.044a.737.737 0 00-1.042 0h0l-3.137 3.137a.737.737 0 000 1.043l2.044 2.035a1.1 1.1 0 01.24 1.2l-1.7 4.085a1.1 1.1 0 01-1.02.679h-2.89a.739.739 0 00-.738.737v4.436a.737.737 0 00.737.738h2.884a1.1 1.1 0 011.02.678l1.7 4.086a1.1 1.1 0 01-.24 1.2l-2.044 2.035a.738.738 0 000 1.044l3.137 3.137a.737.737 0 001.042 0h0l2.033-2.043a1.1 1.1 0 011.2-.239l4.085 1.7a1.1 1.1 0 01.68 1.02v2.884a.739.739 0 00.739.739h4.435a.737.737 0 00.739-.735v-2.888a1.1 1.1 0 01.679-1.02zm-7.712-4.565a8.284 8.284 0 118.284-8.284 8.284 8.284 0 01-8.284 8.284h0zm0 3.427a11.711 11.711 0 1111.71-11.713h0a11.712 11.712 0 01-11.711 11.711h0z",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.607,
    height: 69.607,
    rx: 3,
    transform: "translate(2950.28 4814.777)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2958.997 4828.909)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.151,
    cy: 10.151,
    r: 10.151,
    transform: "translate(15.934 10.521)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14.399,
    cy: 14.399,
    r: 14.399,
    transform: "translate(11.687 6.274)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.839 32.508L5.704 44.641a1.8 1.8 0 01-2.549 0l-1.039-1.039a1.8 1.8 0 010-2.547h0l12.133-12.132m-5.99 5.988l3.589 3.589M0 0h52.173M0 5.168h52.173m-15.935 5.168h15.934M0 10.336h16.063m23.465 5.168h12.645M0 15.504h12.642m27.843 5.169h11.688M0 20.673h11.688m27.841 5.168h12.644M0 25.841h12.642m23.465 5.168h16.065M0 31.009h12.161m1.946 5.169h38.066M0 36.178h6.991m2.011 5.167h43.169M0 41.345h1.879m28.072-22.019h2.691v2.691h-2.691zm-5.211 0h2.691v2.691H24.74zm-5.21 0h2.691v2.691H19.53z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 69.607,
    height: 69.607,
    rx: 3,
    transform: "translate(3144.713 4814.777)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3158.845 4828.909h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3162.332 4832.397h4.249v4.249h-4.249zm11.574-3.488h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3177.393 4832.397h4.249v4.249h-4.249zm11.572-3.488h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3192.453 4832.397h4.249v4.249h-4.249zm-33.608 11.572h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3162.332 4847.457h4.249v4.249h-4.249zm11.574-3.488h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3177.393 4847.457h4.249v4.249h-4.249zm11.572-3.488h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3192.453 4847.457h4.249v4.249h-4.249zm-33.608 11.573h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3162.332 4862.517h4.249v4.249h-4.249zm11.574-3.487h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3177.393 4862.517h4.249v4.249h-4.249zm11.572-3.487h11.225v11.225h-11.225z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3192.453 4862.517h4.249v4.249h-4.249z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 69.607,
    height: 69.607,
    rx: 3,
    transform: "translate(3339.145 4814.777)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3357.561 4840.12v18.924l16.389 9.462 16.389-9.462v-18.924l-16.389-9.461zm16.388 28.386v-18.924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3357.561 4840.12l16.389 9.462 16.389-9.462"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3364.478 4863.042v-19.02l16.385-9.372"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3277.051 4907.406v33.733m0-81.07v36.777m-451.597-47.264h53.311m18.169 0h53.311m423.703 34.802v6.599m0 20.975v6.599m-481.411 34.716h57.707m-57.707 103.872h51.501m-60.878-103.872h-57.706m252.147-51.737h-185.064m416.406 155.606h-94.623m-331.159-155.671h-92.51v17.086m-.001 69.646v68.939h92.51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3364.863 4896.228v10.488l9.086 5.244 9.084-5.244v-10.488l-9.084-5.244z",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2950.31 5050.873a6.269 6.269 0 100 12.538",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3006.213 5038.861h152.066m-152.066 12.357h152.066m-152.066 12.197h152.066m-152.066 12.536h152.066"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3369.304 4898.794v5.358l4.637 2.679 4.641-2.679v-5.358l-4.639-2.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M2887.848 4957.962v94.494"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.689,
    cy: 4.689,
    r: 4.689,
    transform: "translate(2883.16 5052.455)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M2887.848 4907.406v41.178m0-88.515v36.777"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2878.765 4844.339v10.488l9.084 5.244 9.084-5.244v-10.488l-9.084-5.244z",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2883.208 4846.902v5.358l4.639 2.679 4.639-2.679v-5.358l-4.639-2.679z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3073.384 4844.339v10.488l9.086 5.244 9.084-5.244v-10.488l-9.084-5.244z",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3077.829 4846.902v5.358l4.637 2.679 4.639-2.679v-5.358l-4.639-2.679z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.689,
    cy: 4.689,
    r: 4.689,
    transform: "translate(2883.16 4948.584)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.689,
    cy: 4.689,
    r: 4.689,
    transform: "translate(2883.16 4896.847)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.689,
    cy: 4.689,
    r: 4.689,
    transform: "translate(3272.183 4896.847)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3082.469 4907.406v35.445m0-82.782v36.777"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.689,
    cy: 4.689,
    r: 4.689,
    transform: "translate(3077.601 4896.847)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.61,
    height: 69.607,
    rx: 3,
    transform: "translate(2950.308 5022.338)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6e7e9d",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10,
    d: "M2964.013 5035.552h42.2v5.562h-42.2zm0 12.54h42.2v5.562h-42.2zm0 12.538h42.2v5.562h-42.2zm0 12.539h42.2v5.562h-42.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 69.743,
    height: 69.607,
    rx: 3,
    transform: "translate(3144.577 5022.338)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00cd99",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    d: "M3158.282 5035.552h42.333v5.562h-42.333zm0 12.54h42.333v5.562h-42.333zm0 12.538h42.333v5.562h-42.333zm0 12.539h42.333v5.562h-42.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    d: "M3387.32 5048.092v20.719"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.79,
    height: 51.035,
    rx: 3,
    transform: "translate(3308.961 5022.338)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    d: "M3313.523 5026.901h90.667v41.911h-90.667z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 99.808,
    height: 10.065,
    rx: 3,
    transform: "translate(3308.943 5081.88)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10,
    d: "M3347.26 5073.373h23.192v8.507h-23.192zm23.192-4.561v-41.911m0 21.191h33.738m-33.738 11.217h33.738"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3326.848 5033.363)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.606,
    cy: 14.606,
    r: 14.606
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.604 7.752V0m5.357 10.332l6.061-4.834m-4.738 10.631l7.559 1.726M17.578 20.78l3.364 6.984m-9.31-6.987l-3.365 6.987m-.342-11.635L.366 17.855m8.882-7.522L3.185 5.498"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.852,
    cy: 6.852,
    r: 6.852,
    transform: "translate(7.752 7.752)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 69.607,
    height: 69.607,
    rx: 3,
    transform: "translate(3144.716 4918.558)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3155.474 4936.177)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.055,
    cy: 3.055,
    r: 3.055,
    transform: "translate(8.924 22.967)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.306,
    cy: 6.306,
    r: 6.306,
    transform: "translate(5.673 19.716)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.055,
    cy: 3.055,
    r: 3.055,
    transform: "translate(33.922 22.967)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.306,
    cy: 6.306,
    r: 6.306,
    transform: "translate(30.672 19.716)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.672 26.022H1.209A1.206 1.206 0 010 24.815v-7.841a2.611 2.611 0 012.609-2.612h0a2.606 2.606 0 002.386-1.554l2.887-6.5a3.937 3.937 0 013.6-2.342h6.8v22.055h12.385M18.286 3.963v-2.8a1.164 1.164 0 011.165-1.164h26.111a1.164 1.164 0 011.165 1.164v23.646a1.209 1.209 0 01-1.211 1.21h-2.23m-25-14.126h28.44m-28.44-3.982h28.44"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 69.607,
    height: 69.607,
    rx: 3,
    transform: "translate(2950.311 4918.558)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2967.928 4936.176h4.249v4.249h-4.249zm15.061-5.357h4.249v4.249h-4.249zm15.06 5.357h4.249v4.249h-4.249zm-35.479 15.061h4.249v4.249h-4.249zm16.931-3.488h11.225v11.225h-11.225zm23.906 3.488h4.249v4.249h-4.249z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2982.043 4953.361l3.004-3.004 3.005 3.004-3.005 3.004zm-14.115 12.937h4.249v4.249h-4.249zm15.061 5.358h4.249v4.249h-4.249zm15.06-5.358h4.249v4.249h-4.249zm5.358-12.937h-12.681m-11.226.066h-12.681m18.295 5.548v12.681m0-23.907v-12.681m5.612 12.681l7.323-7.323m-18.549 7.323l-7.323-7.323m7.323 18.549l-7.323 7.323m18.549-7.323l7.323 7.323"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 69.607,
    height: 69.607,
    rx: 3,
    transform: "translate(3339.145 4918.558)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3356.689 4937.137)",
    fill: "none",
    stroke: "#6e7e9d",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.649 23.228v-17.3H0l7.847 17.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.495,
    cy: 3.495,
    r: 3.495,
    transform: "translate(9.447 26.009)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.495,
    cy: 3.495,
    r: 3.495,
    transform: "translate(26.656 26.009)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.646 5.932V3.018a3.019 3.019 0 013.018-3.019h3.947M26.658 29.503H16.439m-4.384-19.227h10.141v10.141H12.055zm12.655 5.585h4.554v4.554H24.71zm1.163-5.585h2.23v3.392h-2.23z"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 69.607,
    height: 69.607,
    rx: 3,
    transform: "translate(2755.847 4918.558)",
    fill: "none",
    stroke: "#0c9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2768.817 4932.406)",
    fill: "#0c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.712 0h32.954v5.562H10.712z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.781,
    cy: 2.781,
    r: 2.781
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.712 12.159h32.954v5.562H10.712z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.781,
    cy: 2.781,
    r: 2.781,
    transform: "translate(0 12.159)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.712 24.319h32.954v5.562H10.712z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.781,
    cy: 2.781,
    r: 2.781,
    transform: "translate(0 24.319)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.712 36.478h32.954v5.562H10.712z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.781,
    cy: 2.781,
    r: 2.781,
    transform: "translate(0 36.478)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3281.56 4902.719h83.304m-277.886-1.183h185.204m-198.798-51.959h-53.466m71.635 0h53.158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3073.384 4948.095v10.488l9.086 5.244 9.084-5.244v-10.488l-9.084-5.244z",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3077.829 4950.658v5.358l4.637 2.679 4.639-2.679v-5.358l-4.639-2.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3073.384 4953.335h-53.466m71.635 0h53.158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3267.789 4844.339v10.488l9.084 5.244 9.084-5.244v-10.488l-9.084-5.244z",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3272.232 4846.902v5.358l4.639 2.679 4.638-2.679v-5.358l-4.638-2.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3267.789 4849.577h-53.466m71.635 0h53.158"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3267.789 4946.383v10.488l9.084 5.244 9.084-5.244v-10.488l-9.084-5.244z",
    fill: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3272.232 4948.946v5.358l4.639 2.679 4.638-2.679v-5.358l-4.638-2.679z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#999",
    strokeMiterlimit: 10,
    strokeDasharray: 4,
    d: "M3267.789 4951.622h-53.466m71.635 0h53.158"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustProviderMain);
export default __webpack_public_path__ + "static/media/trustProviderMain.375f7ad4ffee3ec91c1af35ec854dc70.svg";
export { ForwardRef as ReactComponent };